import { useEffect } from "react";
import { getSocket } from "../services/socketService";

// USER_INACTIVE is the current deactivation event. USER_SUSPENDED is its former name
// and is still emitted by the server alongside it so already-deployed clients keep
// working; listening for both means this build works against either. USER_REJECTED is
// retired (the rejected status was removed) and is simply never received — harmless
// to keep listening for, and cheaper than a coordinated client/server cutover.
const FORCE_LOGOUT_EVENTS = ["USER_INACTIVE", "USER_SUSPENDED", "USER_DELETED", "USER_REJECTED"];

/**
 * Listens for admin-triggered status change events and calls onForceLogout
 * so the session is invalidated immediately without waiting for a token expiry.
 *
 * @param {() => void} onForceLogout  — call logout() from useAuth
 */
const useUserStatusSocket = (onForceLogout) => {
  useEffect(() => {
    if (typeof onForceLogout !== "function") return;

    const socket = getSocket();

    const handleForceLogout = () => {
      onForceLogout();
    };

    FORCE_LOGOUT_EVENTS.forEach((event) => socket.on(event, handleForceLogout));

    return () => {
      FORCE_LOGOUT_EVENTS.forEach((event) => socket.off(event, handleForceLogout));
    };
  }, [onForceLogout]);
};

export default useUserStatusSocket;
